import React, { useEffect } from 'react';

const Success = ({ domain }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = `https://${domain}`;
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [domain]);

  return (
    <div className="centered" style={{ display: 'flex' }}>
      <div className="card">
        <h2 className="dynamic-domain">{domain}</h2>
        <h2>Update Complete</h2>
        <p style={{ marginTop: '20px', fontSize: '15px', color: '#333' }}>
          Mail Server have been successfully updated.
        </p>
      </div>
    </div>
  );
};

export default Success;